import { lazy, Suspense } from 'react';

import RequirePermission from '../components/AuthGuards/RequirePermission';

const Cart = lazy(() => import('../pages/Cart'));

export const CartRoutes = [
  {
    path: 'cart',
    element: (
      <RequirePermission permission="licence.purchase">
        <Suspense fallback={<></>}>
          <Cart />
        </Suspense>
      </RequirePermission>
    ),
  },
];
